module.exports = __webpack_public_path__ + "media/img/specialize/mobile/item12-af3d05b26e46df9d8ff90a893ad4b439.svg";